import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {AuthGuard} from './auth-guard.service';
import {AuthRoutingModule} from './auth-routing.module';
import {Auth} from './auth.service';
import {LoginComponent} from './login/login.component';
import {RegistrationComponent} from './registration/registration.component';
import {RoleGuard} from './role-guard.service';

@NgModule({
    imports: [
        SharedModule,
        FormsModule,
        AuthRoutingModule
    ],
    declarations: [LoginComponent, RegistrationComponent],
    providers: [
        Auth,
        AuthGuard,
        RoleGuard
    ]
})
export class AuthModule {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/auth.module.ts